import { Controller } from "@hotwired/stimulus"

// This controller saves or restores the opened stated of a details element in local storage if it can.
//
// Usage example:
//
// <details open
//   data-controller="persistent-details"
//   data-action="toggle->persistent-details#persist"
//   data-persistent-details-storage-key-value="admin-account-details">
//
//   <summary class="cursor-pointer px-5 py-4 font-semibold text-content-default hover:bg-surface-raised">Account details</summary>
//
//   <div>content</div>
// </details>
export default class extends Controller {
  static values = { storageKey: String }

  connect() {
    try {
      const storedState = window.localStorage.getItem(this.storageKeyValue)

      if (storedState !== null) {
        this.element.open = storedState === "open"
      }
    } catch {
      // Keep the native details behavior when storage is unavailable.
    }
  }

  persist() {
    try {
      window.localStorage.setItem(this.storageKeyValue, this.element.open ? "open" : "closed")
    } catch {
      // Keep the native details behavior when storage is unavailable.
    }
  }
}
